import React from "react"
import {OfferFileSignStatus} from "../../../../common/constants/OfferFileSignStatus";
import {makeStyles, Tooltip} from "@material-ui/core";
import Tr from "../../../../../../../../../../translations/Translations";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";


const useStyle = makeStyles(theme => ({
    signature_file: {color: theme.palette.action.disabled},
    not_signed: {color: theme.palette.primary.main},
    signed: {color: theme.palette.common.success},
    wrong_sign_type: {color: theme.palette.common.error},
}))

function OfferFilesTableSignStatus(
    {row}) {
    const classes = useStyle();

    return <>
        {OfferFileSignStatus.NOT_SIGNED === row.signState &&
            <Tooltip title={Tr("file_sign_status_not_signed")} placement="top"><span><ErrorOutlineIcon className={classes.not_signed}/></span></Tooltip>}
        {OfferFileSignStatus.SIGNED === row.signState &&
            <Tooltip title={Tr("file_sign_status_signed")} placement="top"><span><CheckCircleOutlineIcon className={classes.signed}/></span></Tooltip>}
        {OfferFileSignStatus.SIGNATURE_FILE === row.signState &&
            <Tooltip title={Tr("file_sign_status_signature_file")} placement="top"><span><CheckCircleOutlineIcon
                className={classes.signature}/></span></Tooltip>}
        {OfferFileSignStatus.WRONG_SIGN === row.signState && <Tooltip title={Tr("file_sign_status_wrong_sign")} placement="top"><span><ErrorOutlineIcon
            className={classes.wrong_sign_type}/></span></Tooltip>}
    </>
}

export default OfferFilesTableSignStatus;